import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useCustomer } from 'lib/core/hooks'
import { Button, FadeIn } from 'lib/ui/components'
import { Title } from '../../../../components/Styled'
import { Item } from './components/Item'
import { Container } from './components/Styled'
import { FlexWrapper } from 'lib/ui/components/FlexWrapper'

export const List = () => {
  const history = useHistory()
  const { customer } = useCustomer()
  const defaultShippingAddress = customer?.addresses.filter(address => address.isDefaultShipping)
  const defaultBillingAddress = customer?.addresses.filter(address => address.isDefaultBilling)
  const otherAddresses = customer?.addresses.filter(address => !address.isDefaultBilling && !address.isDefaultShipping)

  return (
    <Container>
      <FadeIn>
        <FlexWrapper className='flex-title'>
          <Title>
            My Address Details
          </Title>
          <Link to='/customer/account'>Back</Link>
        </FlexWrapper>
        <div className='cards'>
          {defaultShippingAddress && defaultShippingAddress?.length > 0 && (
            <Item
              address={defaultShippingAddress[0]}
              addressType='defaultShipping'
            />
          )}
          {defaultBillingAddress && defaultBillingAddress?.length > 0 && (
            <Item
              address={defaultBillingAddress[0]}
              addressType='defaultBilling'
            />
          )}
          {otherAddresses?.length && otherAddresses?.length > 0 && (
            <>
              <p><strong>Other Addresses</strong></p>
              {otherAddresses?.map((address, index) => {
                return (
                  <Item
                    key={`${index}`}
                    address={address}
                  />
                )
              })}
            </>
          )}
          <div className='new-card'>
            <Button
              onClick={() => history.push('/customer/account/addresses/add')}
            >
              Add Address
            </Button>
          </div>
        </div>
      </FadeIn>
    </Container>
  )
}
